/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgDynamicPermission
 */
export interface OrgDynamicPermission {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    category: string;
    /**
     * Whether the org has the feature this permission controls enabled.
     */
    is_available: boolean;
}

/**
 * Check if a given object implements the OrgDynamicPermission interface.
 */
export function instanceOfOrgDynamicPermission(value: object): value is OrgDynamicPermission {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('is_available' in value) || value['is_available'] === undefined) return false;
    return true;
}

export function OrgDynamicPermissionFromJSON(json: any): OrgDynamicPermission {
    return OrgDynamicPermissionFromJSONTyped(json, false);
}

export function OrgDynamicPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgDynamicPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
        'category': json['category'],
        'is_available': json['is_available'],
    };
}

export function OrgDynamicPermissionToJSON(json: any): OrgDynamicPermission {
    return OrgDynamicPermissionToJSONTyped(json, false);
}

export function OrgDynamicPermissionToJSONTyped(value?: OrgDynamicPermission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'title': value['title'],
        'description': value['description'],
        'category': value['category'],
        'is_available': value['is_available'],
    };
}

